/* Before checkout, syncs the 'Pre-order' line item property on every cart line (full or partial
   pre-order, or removes a stale note), however the item was added. Never blocks checkout: on any error or after
   a timeout it continues to /checkout. Express/dynamic checkout buttons bypass this. */
(function () {
  var NAME = 'Pre-order', SECTION = 'preorder-cart-data';
  var busy = false, done = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchLines() {
    return fetch(root() + '?sections=' + SECTION, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j[SECTION] || '', 'text/html');
        var el = doc.getElementById(SECTION);
        return el ? JSON.parse(el.textContent || '[]') : [];
      });
  }

  // Change one line at a time; the key changes after each change, so re-read the section.
  function fixNext(n, seen) {
    if (n > 25) return Promise.resolve();
    return fetchLines().then(function (lines) {
      var line = null;
      for (var i = 0; i < lines.length; i++) { if (!seen[lines[i].key]) { line = lines[i]; break; } }
      if (!line) return;
      seen[line.key] = true;
      var props = {};
      var old = line.properties || {};
      if (Array.isArray(old)) { old.forEach(function (p) { if (p && p.length === 2) props[p[0]] = p[1]; }); }
      else { for (var k in old) { if (Object.prototype.hasOwnProperty.call(old, k)) props[k] = old[k]; } }
      if (line.value) { props[NAME] = String(line.value); delete props['_preorder']; } else { delete props[NAME]; }
      // Shopify ignores an empty properties object, so keep one hidden (_-prefixed) placeholder.
      if (!Object.keys(props).length) props['_preorder'] = 'none';
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
      }).then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        return fixNext(n + 1, seen);
      });
    });
  }

  function goCheckout() {
    window.location.href = root() + 'checkout';
  }

  function intercept(e) {
    if (done) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    var timeout = new Promise(function (res) { setTimeout(res, 8000); });
    Promise.race([fixNext(0, {}), timeout])
      .catch(function (err) { if (window.console) console.warn('preorder-checkout:', err); })
      .then(function () { done = true; goCheckout(); });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var t = e.target && e.target.closest
      ? e.target.closest('[name="checkout"], a[href*="/checkout"], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]')
      : null;
    if (t && !t.disabled) intercept(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart"]')) return;
    var s = e.submitter;
    if (s && s.name === 'checkout') intercept(e);
  }, true);

  // Reset when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; done = false; } });
})();
